import { render, staticRenderFns } from "./shareholder-group.vue?vue&type=template&id=1df7603c&"
import script from "./shareholder-group.vue?vue&type=script&lang=ts&"
export * from "./shareholder-group.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports